import { createFileRoute, redirect } from '@tanstack/react-router'
import { AuthenticatedLayout } from '@/features/authenticated-layout/index.ts'
import { AUTH_SESSION_STALE_TIME } from '@/trpc/context.ts'
import { canVisitRoute } from '@/utils/route-access.ts'

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ context, location }) => {
    const session = await context.queryClient.fetchQuery({
      ...context.trpc.auth.session.queryOptions(),
      retry: false,
      staleTime: AUTH_SESSION_STALE_TIME
    })

    if (!session) {
      throw redirect({
        to: '/auth/signin',
        search: { redirect: location.href },
        replace: true
      })
    }
    if (session.status !== 'active' || !session.member) {
      throw redirect({ to: '/auth/status', replace: true })
    }

    if (!canVisitRoute(session, location.pathname)) {
      throw redirect({ to: '/unauthorized', replace: true })
    }

    return { currentSession: { ...session, member: session.member } }
  },
  component: AuthenticatedRoute
})

function AuthenticatedRoute() {
  const { currentSession } = Route.useRouteContext()
  return <AuthenticatedLayout currentSession={currentSession} />
}
